module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"csrfMsg":"Invalid or missing CSRF token","csrfTitle":"CSRF error","msg":"An error occurred, please try logging in again.","login":"Login"},"de":{"csrfMsg":"Ungültiger oder fehlender CSRF Token","csrfTitle":"CSRF Fehler","msg":"Ein Fehler ist aufgetreten, bitte probieren Sie sich erneut anzumelden.","login":"Anmelden"}}')
  delete Component.options._Ctor
}
